// Class
import _ from "lodash";
import ITag = Contact.ITag;
import { Coord } from "./Coord";
import { FactureFournisseur } from "./FactureFournisseur";

export class Contact {
    id?: number;
    nom?: string;
    alt_noms?: string;
    type?: string;
    type_id?: number;
    category?: string;
    category_id?: number;
    syndic_id?: number;
    tags: Array<number> = [];
    adresse: Contact.Adresse | any = {};
    has_users: boolean = false;
    coordonnees: Array<Contact.Coordonnees> = [];
    related_contacts: Array<Contact> = [];
    owned_contacts: Array<Contact> = [];
    factures_fournisseurs: Array<FactureFournisseur> = [];
    archived: boolean = false;

    constructor(data: any) {
        let self = this;
        _.assign(
            self,
            _.omit(data, [
                "coordonnees",
                "related_contacts",
                "owned_contacts",
                "factures_fournisseurs",
            ])
        );
        if (data.type) {
            self.type = data.type.name;
        }
        if (data.category) {
            self.category = data.category.name;
        }
        if (data.coordonnees) {
            _.forEach(data.coordonnees, function (coordonnees) {
                self.coordonnees.push(new Contact.Coordonnees(coordonnees));
            });
        }
        if (data.related_contacts) {
            _.forEach(data.related_contacts, function (contact) {
                self.related_contacts.push(new Contact(contact));
            });
        }
        if (data.owned_contacts) {
            _.forEach(data.owned_contacts, function (contact) {
                self.owned_contacts.push(new Contact(contact));
            });
        }
        if (data.factures_fournisseurs) {
            _.forEach(data.factures_fournisseurs, function (facture) {
                self.factures_fournisseurs.push(
                    new FactureFournisseur(facture)
                );
            });
        }
    }

    get tagsDisplay(): Array<ITag> {
        return _.map(this.tags, function (tId) {
            return Contact.Tag[tId];
        });
    }

    get emails(): Array<Contact.Coordonnees> {
        return _.filter(this.coordonnees, "email");
    }

    // Utils
    get link() {
        return "#/app/client/" + this.id;
    }

    hasTag(tId: Contact.ETag): boolean {
        return this.tags && this.tags.includes(tId);
    }

    serialize(): Contact.IContact {
        return {
            id: this.id,
            nom: this.nom,
            alt_noms: this.alt_noms,
            type_id: this.type_id,
            category_id: this.category_id,
            syndic_id: this.syndic_id,
            tags: this.tags,
            coordonnees: this.coordonnees,
            archived: this.archived,
        };
    }
}

// Enums
export namespace Contact {
    export interface IContact {
        id?: number;
        nom: string;
        alt_noms: string;
        type_id?: number;
        category_id?: number;
        syndic_id?: number;
        tags: Array<number>;
        coordonnees: Array<Contact.Coordonnees>;
        archived?: boolean;
    }

    // Coordonnées
    export class Coordonnees {
        id?: number;
        nom?: string;
        prenom?: string;
        fonction?: string;
        email?: string;
        telephone?: string;
        roles: Array<number> = [];
        __uniqueid = _.uniqueId();

        constructor(data: any) {
            _.assign(this, data);
        }
    }

    // Contact Address
    export interface Adresse {
        id: number;
        adresse: string;
        code_postal: string;
        ville: string;
        pays: string;
        coord?: Coord;
    }

    // Type
    export enum EType {
        Syndic = "Syndic",
        Copropriete = "Copropriété",
        Bureau = "Bureau",
        Particulier = "Particulier",
        Fournisseur = "Fournisseur",
        Prestataire = "Prestataire",
    }

    // Tags
    export interface ITag {
        id: ETag;
        name: string;
        colorClass: string;
    }

    export enum ETag {
        CoproprieteSensible = 1,
    }

    export const Tag: { [index: number]: ITag } = {
        [ETag.CoproprieteSensible]: {
            id: ETag.CoproprieteSensible,
            name: "Copropriété sensible",
            colorClass: "danger",
        },
    };

    export enum ERole {
        absence = "Absence employé",
        statut_intervention = "Statut intervention",
        signalement = "Signalement",
    }
}
